import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as ACT from './actions'
import { Contact } from './Contact'
import { createSelector } from 'reselect'
import { PageTitle } from 'components/common/PageTitle'
import { useParams } from 'react-router-dom'

const selectContact = createSelector([state => state.contact], contact => {
  return contact
})

const selectRoles = createSelector([state => state.roles], roles => {
  return roles
})

const selectDeals = createSelector([state => state.deals], deals => {
  return deals
})

const selectProposals = createSelector([state => state.proposals], proposals => {
  return proposals
})

const selectPipeline = createSelector([state => state.pipeline], pipeline => {
  return pipeline
})

const selectCompanyDeals = createSelector([state => state.companyDeals], deals => {
  return deals
})

const selectCompanyPipeline = createSelector([state => state.companyPipeline], pipeline => {
  return pipeline
})

const ContactContainer = () => {
  const dispatch = useDispatch()
  const params = useParams()

  const contact = useSelector(state => selectContact(state.contact))
  const roles = useSelector(state => selectRoles(state.contact))
  const deals = useSelector(state => selectDeals(state.contact))
  const proposals = useSelector(state => selectProposals(state.contact))
  const pipeline = useSelector(state => selectPipeline(state.contact))
  const companyDeals = useSelector(state => selectCompanyDeals(state.contact))
  const companyPipeline = useSelector(state => selectCompanyPipeline(state.contact))

  useEffect(() => {
    dispatch({
      type: ACT.CONTACT_FETCH_REQUESTED,
      payload: {
        id: params.id
      }
    })
  }, [dispatch, params.id])

  return (
    <>
      <PageTitle detail={contact.firstName ? `${contact.firstName} ${contact.lastName}` : null} />
      <Contact
        contact={contact}
        roles={roles}
        deals={deals}
        proposals={proposals}
        pipeline={pipeline}
        companyDeals={companyDeals}
        companyPipeline={companyPipeline}
      />
    </>
  )
}

export default ContactContainer
